import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=6de3ecef"
import script from "./approval.ts?vue&type=script&lang=js&external"
export * from "./approval.ts?vue&type=script&lang=js&external"
import style0 from "./approval.vue?vue&type=style&index=0&id=6de3ecef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports